import { Avatar, AvatarFallback, AvatarImage, cn } from '@agently/ui';
import { Sparkles } from 'lucide-react';
import { CopilotGlow } from './CopilotGlow';

export function CopilotAvatar({
  className,
  dimGlow = false,
  name,
  size = 'default',
  src,
}: {
  className?: string;
  /** Soften the glow, e.g. for an item that is already active. */
  dimGlow?: boolean;
  name: string;
  size?: 'sm' | 'default';
  /** `null` when the team has no avatar: Sparkles on a gradient circle is shown instead. */
  src: string | null;
}) {
  return (
    <span
      className={cn(
        'relative inline-flex shrink-0 items-center justify-center',
        size === 'sm' ? 'size-8' : 'size-14',
        className,
      )}
    >
      <span
        aria-hidden
        className={cn(
          'pointer-events-none absolute inset-0',
          dimGlow && 'opacity-40',
        )}
        data-slot="copilot-glow"
      >
        <CopilotGlow />
      </span>
      <Avatar className="relative size-full shadow-sm ring-2 ring-background">
        {src ? (
          <>
            <AvatarImage alt={name} src={src} />
            <AvatarFallback>{name.charAt(0)}</AvatarFallback>
          </>
        ) : (
          <AvatarFallback className="bg-linear-to-br from-sky-400 via-violet-500 to-fuchsia-500 text-white">
            <Sparkles aria-label={name} className="size-1/2" />
          </AvatarFallback>
        )}
      </Avatar>
    </span>
  );
}
